import React from "react";
import Navbar from "./global-components/navbar-v3";
import PageHeader from "./global-components/page-header";
import CareersDetails from "./section-components/careers-details";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";

const Careers = () => {
  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Careers" />
      <CareersDetails />
      <CallToActionV1 />
      <Footer />
    </div>
  );
};

export default Careers;
